/*
 * Created by: cparaschiv
 * Date: 24.06.2014, 10:09
 */

TS.ns('TS.data');

(function($, undefined) {
    'use strict';

    var CHANGE = "change",
        DataSource = kendo.data.DataSource,
        HierarchicalDataSource = kendo.data.HierarchicalDataSource,
        unwrap = TS.unwrap;

    function hasChildren(item, childProp, checkedProp) {
        item.hasChildren = !TS.isEmpty(item[childProp]);
        item.uid = item.UID;
        item.checked = unwrap(item[checkedProp]);

        if (item.hasChildren) {
            $.each(item[childProp], function(idx, child) {
                hasChildren(child, childProp, checkedProp);
            });
        }
    }

    function prepareData(data, childProp, checkedPropertyName) {
        var plain,
            i = 0, len;

        // TODO: Expensive, find a way to get plain data from server
        if (TS.isObservable(data)) {
            plain = ko.mapping.toJS(data);
        }
        else {
            plain = data;
        }
        len = plain.length;

        $.each(plain, function(idx, item) {
            hasChildren(item, childProp, checkedPropertyName);
        });

        return plain;
    }

    /**
     * @class TS.data.KoTreeSource
     * @classdesc
     * Datasource for Kendo tree that cand accomodate Knockout observables.
     */
    TS.data.KoTreeSource = HierarchicalDataSource.extend(
        /** @lends TS.data.KoTreeSource# */
        {
        _changes: [],

        init: function (options) {
            var me = this,
                plain;

            options.data = prepareData(options.data, options.schema.model.children, options.checkedPropertyName);

            var node = kendo.data.Node.define({
                children: options,
                idField: 'UID'
            });

            DataSource.fn.init.call(me, $.extend(true, {}, { schema: { modelBase: node, model: node } }, options));

            HierarchicalDataSource.fn._attachBubbleHandlers.call(me);

            //HierarchicalDataSource.fn.init.call(me, options);
            me.__id = TS.newUID();
        }
    });

})(jQuery);